import React, { useState, useEffect } from "react";
import "./Calender.css";
import axios from "axios";
import Notification from "./Notification";
import './bothcss.scss'

const API_URL = "https://ridehire-backend-2.onrender.com/host/reservation-event";

const Calender = ({ selectedMonth, selectedYear }) => {
  console.log(selectedMonth);
  console.log(selectedYear);
  
  const currentDate = new Date();
  const defaultMonth = selectedMonth != null ? selectedMonth  : currentDate.getMonth(); // Adjust month to 0-indexed
  const defaultYear = selectedYear != null ? selectedYear : currentDate.getFullYear();
  console.log(defaultMonth);
  console.log(defaultYear);
  
  const [currentMonth, setCurrentMonth] = useState(defaultMonth);
  const [currentYear, setCurrentYear] = useState(defaultYear);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchEvents();
  }, [currentMonth, currentYear]);

  useEffect(() => {
    setCurrentMonth(selectedMonth !== null ? selectedMonth : currentDate.getMonth());
    setCurrentYear(selectedYear !== null ? selectedYear : currentDate.getFullYear());
  }, [selectedMonth, selectedYear]);
  

  const fetchEvents = async () => {
    try {
      const { data } = await axios.get(API_URL);
      setEvents(Array.isArray(data.events) ? data.events : []);
    } catch (error) {
      setEvents([]);
    }
  };

  const getDaysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (month, year) => new Date(year, month, 1).getDay();

  const isEventDay = (day) => {
    return events.filter((event) => {
      const eventDate = new Date(event.departureStartTime);
      return eventDate.getFullYear() === currentYear &&
        eventDate.getMonth() === currentMonth &&
        eventDate.getDate() === day;
    }).length;
  };

  const renderCalendar = () => {
    const firstDay = getFirstDayOfMonth(currentMonth, currentYear);
    const daysInMonth = getDaysInMonth(currentMonth, currentYear);
    
    // Handle previous month edge case
    const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1;
    const prevYear = currentMonth === 0 ? currentYear - 1 : currentYear;
    const prevMonthDays = getDaysInMonth(prevMonth, prevYear);
    
    const days = [];
  
    // **1️⃣ Fill Previous Month Days (Light Color)**
    for (let i = firstDay; i > 0; i--) {
      days.push(
        <div className="day faded" key={`prev-${i}`}>
          {prevMonthDays - i + 1}
        </div>
      );
    }
  
    // **2️⃣ Fill Current Month Days**
    for (let i = 1; i <= daysInMonth; i++) {
      const eventCount = isEventDay(i);
      days.push(
        <div className="day" key={`day-${i}`}>
          {i}
          <div className="event-dots">
            {Array.from({ length: eventCount }).map((_, idx) => (
              <span className="event-dot" key={idx}></span>
            ))}
          </div>
        </div>
      );
    }
  
    // **3️⃣ Fill Next Month Days (Light Color)**
    const remainingCells = 35 - days.length; // Ensure the full 6-row layout (7x6 = 42)
    for (let i = 1; i <= remainingCells; i++) {
      days.push(
        <div className="day faded" key={`next-${i}`}>
          {i}
        </div>
      );
    }
  
    return days;
  };
  
  useEffect(() => {
    const adjustHeight = () => {
      const calendar = document.querySelector('.calendar-container');
      const notification = document.querySelector('.notification-container');
      if (calendar && notification) {
        notification.style.height = `${calendar.clientHeight}px`;
      }
    };
  
    setTimeout(adjustHeight, 100); // Small delay to allow rendering
  
    window.addEventListener('resize', adjustHeight);
    return () => window.removeEventListener('resize', adjustHeight);
  }, []);
  
  
  

  const resetCalendar = () => {
    setCurrentMonth(currentDate.getMonth());
    setCurrentYear(currentDate.getFullYear());
  };

  return (
    
    <div className="calendar-container ">
    {/* <h1>reservation</h1> */}
      <div className="d-flex w-100">
        <div className="calender p-3 w-100">

          <div className="calendar-grid p-2">
            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
              <div className="day-header" key={day}>{day}</div>
            ))}
            {renderCalendar()}
          </div>
          <div className="sidebar">
            <button onClick={resetCalendar} className="reset">Reset to Current Month</button>
          </div>
        </div>

        <div className="notification">
          <Notification />
        </div>
      </div>
    </div>
  );
};

export default Calender;